module.exports = __webpack_public_path__ + "static/media/Revolutionary Soldier.3d45238c.jpg";